import React, { Component } from "react";
import Event from "./event";

import { getData } from './events-list-fn';

import "./events-list.scss";

// Start here for the events work
var events = getData();

class EventsList extends Component {
  render() {
    if (events.upcoming.length === 0) {
      return (
        <div className="events-list">
          <h2>Upcoming Events</h2>
          <div className="no-events">Check back here for future events.</div>
          <h2>Past Events</h2>
          {events.past.map((event) =>
            <Event event={event} key={event.id} />
          )}
        </div>
      );
    }
    else if (events.upcoming.length !== 0) {
      return (
        <div className="events-list">
          <h2>Upcoming Events</h2>
          {events.upcoming.map((event) =>
            <Event event={event} key={event.id} />
          )}
          <h2>Past Events</h2>
          {events.past.map((event) =>
            <Event event={event} key={event.id} />
          )}
        </div>
      );
    }
  }
}

export default EventsList;